module.exports = {
	name: 'Introduction',
	exampleProps: {
		imageUrl: 'https://content-randomizer.netlify.app/images/templates/explorer/6.jpg',
		text:
			"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum"
	},
	template: [
		{
			name: 'Right Page',
			type: 'page',
			props: {
				width: { '?': { var: '$theme.pageWidth' } },
				height: { '?': { var: '$theme.pageHeight' } },
				classNames: ['page-introduction', 'page-right']
			},
			children: [
				{
					name: 'Background image',
					type: 'image',
					props: {
						width: '100%',
						height: '100%',
						position: 'absolute',
						objectFit: 'cover',
						src: { '?': { var: '$props.imageUrl' } }
					}
				}
			]
		},
		{
			name: 'Left Page',
			type: 'page',
			props: {
				width: { '?': { var: '$theme.pageWidth' } },
				height: { '?': { var: '$theme.pageHeight' } },
				classNames: ['page-introduction']
			},
			children: [
				{
					name: 'Introduction page content',
					type: 'container',
					props: {
						padding: '11px 11px 11px 11px'
					},
					children: [
						{
							type: 'container',
							props: {
								width: '100%',
								height: '100%',
								padding: '70px 60px 70px 60px',
								display: 'flex',
								fontFamily: 'Poppins'
							},
							children: [
								{
									type: 'container',
									children: [
										{
											name: 'Header',
											type: 'text',
											props: {
												fontSize: '30px',
												textTransform: 'uppercase',
												margin: '0',
												letterSpacing: '2',
												value: 'Introduction'
											}
										},
										{
											name: 'Text',
											type: 'text',
											props: {
												value: { '?': { var: '$props.text' } },
												width: '95%',
												display: 'flex',
												flexDirection: 'column',
												marginTop: '40px'
											}
										}
									]
								}
							]
						}
					]
				}
			]
		}
	]
};
